export const ApiAccessTypes = {
    API_ACCESS_ROLES_REQUEST: 'API_ACCESS_ROLES_REQUEST',
    API_ACCESS_ROLES_SUCCESS: 'API_ACCESS_ROLES_SUCCESS',
    API_ACCESS_ROLES_FAILED: 'API_ACCESS_ROLES_FAILED',
    API_ACCESS_USERS_REQUEST: 'API_ACCESS_USERS_REQUEST',
    API_ACCESS_USERS_SUCCESS: 'API_ACCESS_USERS_SUCCESS',
    API_ACCESS_USERS_FAILED: 'API_ACCESS_USERS_FAILED',
    API_ACCESS_CREATE_USER_REQUEST: 'API_ACCESS_CREATE_USER_REQUEST',
    API_ACCESS_CREATE_USER_SUCCESS: 'API_ACCESS_CREATE_USER_SUCCESS',
    API_ACCESS_CREATE_USER_FAILED: 'API_ACCESS_CREATE_USER_FAILED',
    API_ACCESS_CREATE_USER_CLEAR_STATUS: 'API_ACCESS_CREATE_USER_CLEAR_STATUS',
    API_ACCESS_UPDATE_USER_REQUEST: 'API_ACCESS_UPDATE_USER_REQUEST',
    API_ACCESS_UPDATE_USER_SUCCESS: 'API_ACCESS_UPDATE_USER_SUCCESS',
    API_ACCESS_UPDATE_USER_FAILED: 'API_ACCESS_UPDATE_USER_FAILED',
    API_ACCESS_UPDATE_USER_CLEAR_STATUS: 'API_ACCESS_UPDATE_USER_CLEAR_STATUS',
    API_ACCESS_UPDATE_PASSWORD_REQUEST: 'API_ACCESS_UPDATE_PASSWORD_REQUEST',
    API_ACCESS_UPDATE_PASSWORD_SUCCESS: 'API_ACCESS_UPDATE_PASSWORD_SUCCESS',
    API_ACCESS_UPDATE_PASSWORD_FAILED: 'API_ACCESS_UPDATE_PASSWORD_FAILED',
    API_ACCESS_UPDATE_PASSWORD_CLEAR_STATUS: 'API_ACCESS_UPDATE_PASSWORD_CLEAR_STATUS',
    API_ACCESS_USER_REQUEST: 'API_ACCESS_USER_REQUEST',
    API_ACCESS_USER_SUCCESS: 'API_ACCESS_USER_SUCCESS',
    API_ACCESS_USER_FAILED: 'API_ACCESS_USER_FAILED',
    API_ACCESS_USER_ENDPOINTS_REQUEST: 'API_ACCESS_USER_ENDPOINTS_REQUEST',
    API_ACCESS_USER_ENDPOINTS_SUCCESS: 'API_ACCESS_USER_ENDPOINTS_SUCCESS',
    API_ACCESS_USER_ENDPOINTS_FAILED: 'API_ACCESS_USER_ENDPOINTS_FAILED',
    API_ACCESS_CLEAR_DETAILS: 'API_ACCESS_CLEAR_DETAILS',
};

export const getApiAccessRolesRequest = () => ({
    type: ApiAccessTypes.API_ACCESS_ROLES_REQUEST,
});

export const getApiAccessRolesSuccess = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_ROLES_SUCCESS,
    payload,
});

export const getApiAccessUsersRequest = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_USERS_REQUEST,
    payload,
});

export const getApiAccessUsersSuccess = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_USERS_SUCCESS,
    payload,
});

export const createApiAccessUserRequest = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_CREATE_USER_REQUEST,
    payload,
});

export const createApiAccessUserSuccess = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_CREATE_USER_SUCCESS,
    payload,
});

export const clearApiAccessCreateUserStatus = () => ({
    type: ApiAccessTypes.API_ACCESS_CREATE_USER_CLEAR_STATUS,
});

export const updateApiAccessUserRequest = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_UPDATE_USER_REQUEST,
    payload,
});

export const updateApiAccessUserSuccess = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_UPDATE_USER_SUCCESS,
    payload,
});

export const clearApiAccessUpdateUserStatus = () => ({
    type: ApiAccessTypes.API_ACCESS_UPDATE_USER_CLEAR_STATUS,
});

export const updateApiAccessPasswordRequest = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_UPDATE_PASSWORD_REQUEST,
    payload,
});

export const updateApiAccessPasswordSuccess = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_UPDATE_PASSWORD_SUCCESS,
    payload,
});

export const clearApiAccessUpdatePasswordStatus = () => ({
    type: ApiAccessTypes.API_ACCESS_UPDATE_PASSWORD_CLEAR_STATUS,
});

export const getApiAccessUserRequest = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_USER_REQUEST,
    payload,
});

export const getApiAccessUserSuccess = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_USER_SUCCESS,
    payload,
});

export const getApiAccessUserEndpointsRequest = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_USER_ENDPOINTS_REQUEST,
    payload,
});

export const getApiAccessUserEndpointsSuccess = (payload?: any) => ({
    type: ApiAccessTypes.API_ACCESS_USER_ENDPOINTS_SUCCESS,
    payload,
});

export const clearApiAccessDetails = () => ({
    type: ApiAccessTypes.API_ACCESS_CLEAR_DETAILS,
});
